class AddExtraAccountingSessionToStayReq {
    constructor() {
        this.sessionId = null;
        this.domesticStayId = null;
        this.finalPrice = null;
        this.quantity = null;
    }
}
export default AddExtraAccountingSessionToStayReq;